import { LOCAL_SECURITY_QEUSTION_ANSWERED, LOCAL_STORAGE_ACCOUNT_PROFILE } from "constants/localStore";
import {
  getLocalStorageItem,
  getLocalStorageOneItem,
  setLocalStorageArrayObject,
  setLocalStorageOneItem,
} from "utils/localStorage";
import { IAccountProfile, IFMCGProfile, IStoreCategoryNames } from "interfaces/account/accountProfile.interface";
import { RETAIL_TYPE_ONLINE } from "constants/storeFormat";
import { parseJSONObjectString } from "./utils";
import { IStoreCredentials } from "interfaces/localStore/authLocalStore.interface";
import { actionUpdateWelcomeReducer } from "redux/slices/authorizationSlice";
import { Dispatch } from "react";
import { AnyAction } from "@reduxjs/toolkit";
import { IProfileState } from "interfaces/redux/reducers";

const saveProfileToLocalDB = (profileDetails: IAccountProfile) => {
  const { store, fmcg_profile: fmcgProfileJSONString } = profileDetails;
  const { address = null, name = null } = store;
  const fmcgProfile = parseJSONObjectString(fmcgProfileJSONString as any as string) as IFMCGProfile;

  const storeCredentials: IStoreCredentials = {
    fmcg_account_id: fmcgProfile?.account?.id ?? "",
    fmcg_store_id: fmcgProfile?.account?.store?.id ?? "",
    username: fmcgProfile?.account?.username ?? "",
    name: name || "",
    address: address || "",
  };

  setLocalStorageArrayObject(LOCAL_STORAGE_ACCOUNT_PROFILE, storeCredentials);
};

const getProfileToLocalDB = () => {
  return getLocalStorageItem(LOCAL_STORAGE_ACCOUNT_PROFILE, {}) as IStoreCredentials;
};

const isOnlineRetailer = (retailerType: string) => retailerType === RETAIL_TYPE_ONLINE;

const isSecurityQuestionsAnswered = (getProfileResponse: any, isJSONParse: boolean = true) => {
  const fmcg_profile = isJSONParse
    ? parseJSONObjectString(getProfileResponse?.fmcg_profile as any as string)
    : (getProfileResponse as IFMCGProfile);

  return !!fmcg_profile?.account?.store?.security_questions_answered;
};

const toWelcomeNavigationRoutes = (dispatch: Dispatch<AnyAction>, shouldDisplayWelcoming: boolean) => {
  dispatch(
    actionUpdateWelcomeReducer({
      isWelcomed: false,
      isWelcoming: shouldDisplayWelcoming,
    }),
  );
};

const isSecurityQuestionsAnsweredChecked = () => {
  return !!getLocalStorageOneItem(LOCAL_SECURITY_QEUSTION_ANSWERED);
};

const setSecurityQuestionsAnsweredChecked = (isAnswered: boolean) => {
  if (isAnswered) {
    setLocalStorageOneItem(LOCAL_SECURITY_QEUSTION_ANSWERED, `${isAnswered}`);
  }
};

const getAccountProfile = (profile: IProfileState) => {
  const accountDetails = {
    storeName: "",
    mobileNumber: "",
  };

  try {
    const { fmcg_profile: fmcgProfile } = profile;
    const { account } = fmcgProfile;
    const { store } = account;
    accountDetails.storeName = store.name || "";
    accountDetails.mobileNumber = store.contact_no || "";
  } catch {}

  return accountDetails;
};

const getStoreCategoryName = (profile: IProfileState) => {
  let storeCategoryName = "" as IStoreCategoryNames;

  try {
    storeCategoryName = (profile?.store?.store_category?.name || "") as IStoreCategoryNames;
  } catch {}

  return storeCategoryName;
};

export {
  saveProfileToLocalDB,
  isOnlineRetailer,
  getProfileToLocalDB,
  isSecurityQuestionsAnswered,
  toWelcomeNavigationRoutes,
  isSecurityQuestionsAnsweredChecked,
  setSecurityQuestionsAnsweredChecked,
  getAccountProfile,
  getStoreCategoryName,
};
